// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"75f59c3470f577b9","3870":"af3deeb3e9653e18","7170":"af3deeb3e9653e18"}[chunkId] + ".css";
};